import CreateOffer from './CreateOffer';

export default CreateOffer;
